<template>
  <div :id="option.id" @click="selectButton" :class="[selectedStyle(), loadingTileStyle()]"  class="big-radio-button">
    <div :class="{'animated-background': loading}">
        <div v-if="loading" key="loading">
         <div class="background-masker header-top"></div>
            <div class="background-masker header-left"></div>
            <div class="background-masker header-right"></div>
            <div class="background-masker header-bottom"></div>
            <div class="background-masker subheader-left"></div>
            <div class="background-masker subheader-right"></div>
            <div class="background-masker subheader-bottom"></div>
            <div class="background-masker content-top"></div>
            <div class="background-masker content-first-end"></div>
            <div class="background-masker content-second-line"></div>
            <div class="background-masker content-second-end"></div>
        </div>
      <div class="icon big-font" :class="[option.icon]"></div>
      <h3>{{ option.displayValue }}</h3>
      <p>{{ option.description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BigRadioButton',
  props: {
    option: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      required: false
    }
  },
  methods: {
    selectButton () {
      this.$emit('select', this.option)
    },
    selectedStyle () {
      return this.selected ? 'active' : 'inactive'
    },
    loadingTileStyle () {
      return this.loading ? 'timeline-item' : ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/shipbob-custom/components/utils/tile-loader.scss';
.big-radio-button {
  cursor: pointer;
  min-width: 150px;
  min-height: 200px;
  width: 47%;
  -webkit-box-shadow: 0px 4.5px 15px -3.5px rgba(0,0,0,0.75);
  -moz-box-shadow: 0px 4.5px 15px -3.5px rgba(0,0,0,0.75);
  box-shadow: 0px 4.5px 15px -3.5px rgba(0,0,0,0.75);
  border-radius: 6px;
  padding: 1.5em;
}
.big-font {
  font-size: 3em;
}
.big-radio-button {
  .icon {
    margin-top: 0.25em;
    margin: 0;
  }
  h3 {
    margin: 0;
    margin-top: 0.5em;
  }
  p {
    font-size: 14px;
    color: #737883;
    margin: 0;
  }
}
.active {
  background-color: #2470af;
  color: white;
  h3 {
    color: white;
  }
  p {
    color: white;
  }
  p {
    color: white;
  }
}
</style>
